export default class CancelToken {
  public static source() {
    let cancel: any;
    const token = new CancelToken((c: any) => {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }

  public promise: any;
  public reason?: any;
  constructor(executor: any) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise: any;
    const token = this;
    this.promise = new Promise((resolve, reject) => {
      resolvePromise = reject;
    });
    executor((message: any) => {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }
      token.reason = message;
      resolvePromise(token.reason);
    });
  }

  public throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
}
